import { render } from "./Loader.vue?vue&type=template&id=47b2ebd8"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=47b2ebd8&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__